import React from "react";
import { StockEntryHeaderSection } from './widgets/StockEntryHeaderSection';
import { StockEntryDetailsSection } from './widgets/StockEntryDetailsSection';
import { StockEntryItemsSection } from './widgets/StockEntryItemsSection';
import { StockEntryValueSummarySection } from './widgets/StockEntryValueSummarySection';
import { StockEntryTimelineSection } from './widgets/StockEntryTimelineSection';
import { StockEntryActionsSection } from './widgets/StockEntryActionsSection';
import { GenericSection } from '../sales-order';
import type { ShopifySectionWidgetProps } from './types';

// Export all widgets
export {
  StockEntryHeaderSection,
  StockEntryDetailsSection,
  StockEntryItemsSection,
  StockEntryValueSummarySection,
  StockEntryTimelineSection,
  StockEntryActionsSection,
  GenericSection,
};

// Export widget map
export const STOCK_ENTRY_WIDGETS: Record<string, React.ComponentType<ShopifySectionWidgetProps>> = {
  "stock-entry-overview": StockEntryHeaderSection,
  "stock-entry-details": StockEntryDetailsSection,
  "items": StockEntryItemsSection,
  "status-summary": StockEntryValueSummarySection,
  "stock-entry-timeline": StockEntryTimelineSection,
  "stock-entry-actions": StockEntryActionsSection,
  // Dynamic tabs still use GenericSection so inline editing of raw ERPNext
  // meta fields continues to work in the "Additional Details" and
  // "More Information" tabs.
  "stock-entry-additional-details": GenericSection,
  "stock-entry-more-info": GenericSection,
};

// Re-export types
export type { ShopifySectionWidgetProps } from './types';
